import { UserTypes, useUserDispatch } from '../contexts/UserContext';
import { useNavigate } from 'react-router-dom';

export const useLogOut = () => {
    const dispatch = useUserDispatch();
    const navigate = useNavigate();
    
    return () => {
        localStorage.clear();
        dispatch({ type: UserTypes.CLEAR_PROFILE });
        navigate('/');
    };
}; 